import { render, staticRenderFns } from "./VnpayError.vue?vue&type=template&id=6cb91755&"
import script from "./VnpayError.vue?vue&type=script&lang=ts&"
export * from "./VnpayError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports